import {Component, inject, model, ModelSignal, ViewEncapsulation} from '@angular/core';
import {GridOptions} from 'ag-grid-community';
import {changes, EControlActions, EsvgFiles, IControlDataChanged, UserListTableService} from 'frontier/nucleus';
import {SharedGridOptions} from '../../components/control/table-control/shared-gridoptions.const';
import {ITableAction} from "../../components/control/table-control/interfaces/actions.interface";
import {CSV_EXPORT_ACTION,} from "../../components/control/table-control/default-table-actions.constant";
import {concatMap, filter, tap} from "rxjs/operators";
import {Observable, Unsubscribable} from "rxjs";
import {TableControlComponent} from "../../components/control/table-control/table-control.component";
import {DialogService} from "../../dialogs/dialog.service";
import LibControlGuids from 'frontier/nucleus/src/lib/apiv2/ControlGuids';
import {OnTabActivated} from '../../components/home-without-gl/tabs/tab-activated.interface';
import {
  CreateUserDialogComponent
} from 'frontier/browserkit/src/lib/views/user-list/create-user-dialog/create-user-dialog.component';
import {TableControlModule} from 'frontier/browserkit';
import {USER_LIST_HELP, UserListHelpConfig} from './user-list-help.token';

@Component({
  selector: 'kpi4me-user-list',
  templateUrl: '../../components/control/table-control/table-control.component.html',
  styleUrl: '../../components/control/table-control/table-control.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [TableControlModule],
})
export class UserListComponent extends TableControlComponent implements OnTabActivated {
  private _userListService: UserListTableService = inject(UserListTableService);
  private _dialogService: DialogService = inject(DialogService);
  private _helpConfig: UserListHelpConfig | null = inject(USER_LIST_HELP, {optional: true});
  override GUID: string = LibControlGuids.TUserListTable;

  override gridOptions: GridOptions = {
    ...SharedGridOptions,
    rowSelection: 'single',
  };
  override actions: ModelSignal<ITableAction[]> = model<ITableAction[]>([
    CSV_EXPORT_ACTION, {
      displayName: 'Nutzer anlegen',
      controlAction: EControlActions.resetpassword,
      disabledIfNoSelection: false,
      disabledIfMultiSelection: false,
      color: 'primary',
      icon: EsvgFiles.add,
      action: (): Observable<boolean> => this.openCreateUserDialog(),
    },
  ]);

  constructor() {
    super();
    // Show the toolbar help icon with the project-supplied role descriptions when opted in.
    this.helpComponent = this._helpConfig?.helpComponent ?? null;
    this.subs.add(
      this.controlStore.controlDataChanged$.pipe(
        filter((evt: IControlDataChanged): boolean => {
          return new Map([
            [LibControlGuids.TUserGroupListTable, changes],
          ]).get(evt.GUID)?.has(evt.changeType);
        }),
        tap((): void => {
          this.refreshInfiniteCache();
        })).subscribe(),
    );
  }

  private openCreateUserDialog(): Observable<boolean> {
    return this._dialogService.dialog.open(CreateUserDialogComponent, {
      width: '80vw',
      maxWidth: '35rem',
    }).afterClosed().pipe(
      filter((v: any): boolean => !!v),
      concatMap((dialogResult: string[]): Observable<boolean> => {
        return this._userListService.userListTableNewUser({InstanceId: this.instanceId(), login: dialogResult})
      }),
      tap((): Unsubscribable => this.changeAndFetchInstance())
    );
  }
}
